import { FileInput } from '@/components/ui/FileInput';
import { Textarea } from '@/components/ui/Textarea';
import { openStoredFileInNewTab } from '@/utils/openStoredFile';
type Props = {
  reason: string;
  onReasonChange: (value: string) => void;
  attachmentFile?: File | null;
  onAttachmentFileChange?: (file: File | null) => void;
  existingAttachmentUrl?: string | null;
  onClearExistingAttachment?: () => void;
  uploading?: boolean;
  reasonLabel?: string;
  attachmentLabel?: string;
  attachmentHint?: string;
};

export function HrLeaveReasonAttachmentFields({
  reason,
  onReasonChange,
  attachmentFile = null,
  onAttachmentFileChange,
  existingAttachmentUrl,
  onClearExistingAttachment,
  uploading = false,
  reasonLabel = 'Reason',
  attachmentLabel = 'Supporting document (optional)',
  attachmentHint = 'Upload a medical certificate, travel ticket, or other supporting file if needed.',
}: Props) {
  const showExisting =
    Boolean(existingAttachmentUrl?.trim()) && !attachmentFile && onClearExistingAttachment;

  return (
    <div className="space-y-3">
      <Textarea
        label={reasonLabel}
        value={reason}
        onChange={(e) => onReasonChange(e.target.value)}
        rows={3}
        required
        maxLength={500}
      />
      <FileInput
        label={attachmentLabel}
        hint={attachmentHint}
        variant="compact"
        accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx"
        value={attachmentFile}
        loading={uploading}
        onChange={(files) => onAttachmentFileChange?.(files[0] ?? null)}
        onClear={() => onAttachmentFileChange?.(null)}
      />
      {showExisting ? (
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <button
            type="button"
            onClick={() => void openStoredFileInNewTab(existingAttachmentUrl)}
            className="font-medium text-primary-600 hover:underline dark:text-primary-400"
          >
            View current attachment
          </button>
          <button
            type="button"
            className="text-slate-500 hover:text-slate-700 hover:underline dark:text-slate-400 dark:hover:text-slate-200"
            onClick={onClearExistingAttachment}
          >
            Remove
          </button>
        </div>
      ) : null}
    </div>
  );
}
